class ValidationInput {
	// Getting criteria list with kebab-cased name and validity parameter
	static criteriaList = {
			isRequired: {
				kebab: 'is-required',
				validityCheck: 'valueMissing',
			},
			pattern: {
				kebab: 'pattern',
				validityCheck: 'patternMismatch',
			},
			minLength: {
				kebab: 'min-length',
				validityCheck: 'tooShort',
			},
			maxLength: {
				kebab: 'max-length',
				validityCheck: 'tooLong',
			},
			confirmPassword: {
				kebab: 'confirm-password',
				validityCheck: null
			}
		};

	// On focus, we show all criteria
	static showCriteria(input, formId) {
		input.classList.remove('is-invalid')
		// For each criterion, if we need to control this input, we show it up
		Object.entries(this.criteriaList).forEach(([criteria, value]) => {
			if(criteria === 'confirmPassword') return
			const errorElement = this.getErrorElement(input.id,criteria,value.kebab)
			errorElement?this.displayCriteria(errorElement, true):'';
		});

		// We need to show the confirmPassword criteria even if we are in the password input
		(input.id === 'createUserPassword' || input.id === 'createUserConfirmPassword') && document.querySelector(`.error-createUserConfirmPassword.confirm-password`)
			? this.displayCriteria(document.querySelector(`.error-createUserConfirmPassword.confirm-password`), true)
			:'';

		// To format all criteria
		this.formatCriteria(input, formId)
	}

	// On key up
	static checkInput(input,formId){
		// Clear back-end error message
		document.querySelector(`.back-error-${ input.id }`)?.classList.add('d-none')
		document.querySelector(`.back-error-${ input.id }`)?.classList.remove('d-flex');

		// Update criteria appearance
		this.formatCriteria(input, formId)

		// Submit button management
		this.isSubmitable(formId);
	}

	// On blur
	static inputHandling(input) {
		// Hide validated criteria
		Object.entries(this.criteriaList).forEach(([criteria, value]) => {
			const errorElement = this.getErrorElement(input.id,criteria,value.kebab)
			if(!errorElement) return
			this.displayCriteria(errorElement,errorElement.querySelector('.fa-cross'))
		});

		// Global error handling
		document.querySelector(`.error-${input.id} > .fa-cross`)?input.classList.add('is-invalid'):input.classList.remove('is-invalid');
		if(input.id === 'createUserPassword') {
			document.querySelector(`.error-createUserConfirmPassword.confirm-password`).querySelector('.fa-cross')
				? document.getElementById('createUserConfirmPassword').classList.add('is-invalid')
				: document.getElementById('createUserConfirmPassword').classList.remove('is-invalid');
		}
	}

	//////////////// TOOLS

	// Getting the error DOM element
	static getErrorElement(inputId, criteria, kebab) {
		const selector = inputId === 'createUserPassword' && criteria === 'confirmPassword'?`.${kebab}`:`.error-${inputId}.${kebab}`;
		return document.querySelector(selector);
	}

	// Displaying criteria: Display = true to show criteria
	static displayCriteria(criteria, display) {
		if (display) {
			criteria.classList.remove('d-none');
			criteria.classList.add('d-flex');
		} else {
			criteria.classList.add('d-none');
			criteria.classList.remove('d-flex');
		}
	}

	// Update criteria appearance
	static formatCriteria(input) {
		const validityState = input.validity;

		// If empty value, all rules are false
		if(!input.value){
			Object.entries(this.criteriaList).forEach(([criteria, value]) => {
				const errorElement = this.getErrorElement(input.id,criteria, value.kebab)
				errorElement?this.handleError(errorElement, true):'';
			});
			return
		}

		// Managing rules appearance individually
		Object.entries(this.criteriaList).forEach(([criteria, value]) => {
			const errorElement = this.getErrorElement(input.id,criteria, value.kebab)
			if(!errorElement) return
			if(criteria === 'confirmPassword'){
				this.handleError(errorElement,document.getElementsByName('password')[0].value !== document.getElementsByName('passwordVerify')[0].value);
				return;
			}
			this.handleError(errorElement, validityState[value.validityCheck]);
		});
	}

	// Handle criteria colors, criteria marks and submit button behaviour
	static handleError(criteria, isError) {
		// Ensure "criteria" is a valid DOM element before modifying the DOM
		if (!(criteria instanceof Element)) {
			return;
		}

		// Remove the existing icon
		if (criteria.firstChild.tagName === 'I') {
			criteria.removeChild(criteria.firstChild);
		}

		// Create a new icon element
		const icon = document.createElement('i');

		// Set the cross or check
		if (isError) {
			icon.className = 'fa-kit fa-cross';
			icon.style.color = 'var(--variant-6)'; // Set error style
		} else {
			icon.className = 'fa-solid fa-check';
			icon.style.color = 'var(--variant-1)'; // Set success style
		}

		// Insert the icon as the first child of "criteria"
		criteria.insertBefore(icon, criteria.firstChild);
	}
	static isSubmitable(formId){
		const submitBtn = document.querySelector(`#${ formId } button[type=submit]`)

		// Submit button management: if there is a cross with a parent displayed
		submitBtn.disabled = Array.from(document.querySelectorAll('.fa-cross')).some((element) => {
			return !element.parentElement.classList.contains('d-none');
		});
	}

	///////////// Old way to validate forms
	static validateInput(input, formId) {
		const errorElement = document.querySelector(`.invalid-feedback.error-${ input.id }`);
		const form = document.querySelector(`#${ formId }`);
		const validityState = input.validity;
		
		if (validityState.valueMissing) {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputMandatoryKey;
		} else if (validityState.patternMismatch && input.type === 'email') {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputInvalidmailKey;
		} else if (validityState.patternMismatch && input.name === 'username') {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputInvalidusernameKey;
		} else if (validityState.patternMismatch) {
			input.classList.add('is-invalid');
			errorElement.textContent = input.dataset.translatePatternError;
		} else if (validityState.tooShort) {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputShortKey;
		} else if (validityState.tooLong) {
			input.classList.add('is-invalid');
			errorElement.textContent = form.dataset.inputLongKey;
		} else {
			input.classList.remove('is-invalid');
		}
		this.disableSubmitBtn(formId);
	}
	
	static resetInput(input) {
		input.setCustomValidity('');
	}
	
	static checkMismatchInput(input, compareValue, formId) {
		const password = document.querySelector('input[name="password"]');
		const passwordVerify = document.querySelector('input[name="passwordVerify"]');
		const errorElement = document.querySelector(`.invalid-feedback.error-${passwordVerify.id}`);

		if (password.value !== passwordVerify.value) {
			passwordVerify.classList.add('is-invalid');
			errorElement.textContent = passwordVerify.dataset.mismatchPassword;
		} else {
			passwordVerify.classList.remove('is-invalid');
			this.resetInput(passwordVerify);
		}
		this.disableSubmitBtn(formId);
	}
	
	static validatePasswordInput(input, formId) {
		if(input.dataset.showCriteria){
			return;
		}
		const form = document.querySelector(`#${ formId }`);
		const errorElement = document.querySelector(`.invalid-feedback.error-${ input.id }`);
		const criteriaInputList = {
			'containLowercase': /[a-z]/.test(input.value),
			'containUppercase': /[A-Z]/.test(input.value),
			'containNumber': /\d/.test(input.value),
			'containSpecialCharacter': /[_&#"@%$*!?-]/.test(input.value),
		};
		let rulesCheckedCategory = 0;
		
		Object.values(criteriaInputList).map((criteriaInput) => {
			if (criteriaInput) {
				rulesCheckedCategory += 1;
			}
		});
		
		if (rulesCheckedCategory >= parseInt(form.dataset.categoryAccepted)) {
			input.classList.remove('is-invalid');
			errorElement.textContent = '';
			
			this.validateInput(input, formId);
			
			if (input.classList.contains('is-invalid')) {
				input.classList.remove('was-validated');
			} else {
				input.classList.add('was-validated');
			}
			
		} else {
			input.classList.add('is-invalid');
			input.classList.remove('was-validated');
			errorElement.textContent = input.dataset.weakPasswordKey;
		}
		
	}
	
	static disableSubmitBtn(formId) {
		const inputList = document.querySelectorAll(`#${ formId } input`);
		const selectList = document.querySelectorAll(`#${ formId } select`);
		const submitBtn = document.querySelector(`#${ formId } button[type=submit]`);
		const formHasInvalidInput = (element) => element.classList.contains('is-invalid');
		const emptyValueRequiredInputList = Array.from(inputList).filter((input) => input.value.length === 0 && input.required);
		
		submitBtn.disabled = Array.from(inputList).some(formHasInvalidInput) | Array.from(selectList).some(formHasInvalidInput) | emptyValueRequiredInputList.length > 0;
	}
}

module.exports = ValidationInput;